<template>
  <div>
    <v-snackbar v-model="errorMessage" :timeout="80000" top color="white">
      <span class="red--text">{{msg}}</span>
      <v-icon @click="errorMessage = false" color="red">mdi-close</v-icon>
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card class="pa-7" color="#e0e0e0" >
          <v-card-text class="text-center">
              <v-avatar color="white" size="90" class="mt-n3">
                  <v-icon color="green" x-large>mdi-check-bold</v-icon>
              </v-avatar>
          </v-card-text>
          <v-card-text class="text-center text-color">Your Investment was successfully cancelled.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn to="/dashboard">OKay</v-btn>
            
          </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card class="pa-7" color="#e0e0e0" >
          
          <v-card-text class="text-center text-color">You are about to cancel this investment. If you have not paid this will be completely deleted, if you have paid. Please contact admin for support. Do you want to continue?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="cancel()" :loading="loader">Yes</v-btn>
            <v-btn @click="dialog=false">No</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
  <v-container>
    <div class="mt-8 mx-3">
         <router-link to="/dashboard" class="" style="text-decoration: none; color:#48c074;"><v-icon left style="color:#48c074;">mdi-arrow-left</v-icon>Back</router-link>
      </div>
   <h3 class="mt-7 mx-3">My {{Investment.name}} Details</h3>
    <div class="container mt-4">
        <div class="row justify-content-center">
        <div class="col-lg-6">
            <div class="card fund">
            <div class="card-body card-product">
                <div class="text-center">
                <img width="215" height="139.47" :src="getImageUrl(Investment.farm_img_url)" class="img-fluid" alt="third"  />
                </div>
                <h5 class="card-title text-center mt-2"> {{Investment.name}} </h5>

                <!-- number of units -->
                    
                <!-- <h6 class="card-text mt-4 text-color">Number Of Units: <span style="font-weight: bold;">{{Investment.no}}</span></h6> -->
                    <h6 class="card-text mt-3 text-color">Investment Cost: <span style="font-weight: bold;">&#8358;{{Investment.cost}}</span> <small>per unit</small> </h6>
                    <h6 class="card-text mt-3 text-color">Investment Code: <span style="font-weight: bold;">{{Investment.investment_code}}</span> </h6>
                    <h6 class="card-text mt-3 text-color" >Unit(s) Purchased: <span style="font-weight: bold;">{{Investment.units_bought}}</span></h6>
                    <h6 class="card-text mt-3 text-color" >Amount Paid: <span style="font-weight: bold;">&#8358;{{Investment.amount_paid}}</span></h6>
                    <h6 class="card-text text-color mt-3" v-if="Investment.estimated_return!==''">Estimated returns: <span style="font-weight: bold;">&#8358;{{Investment.estimated_return}}</span></h6>
                    <h6 class="card-text text-color mt-3">Duration: <span style="font-weight: bold;">{{Investment.duration}}</span></h6>
                    <h6 class="card-text text-color mt-3">ROI:  <span style="font-weight: bold;">{{Investment.roi}}%</span></h6>
                    <h6 class="card-text text-color mt-3" v-if="Investment.isPaid===false">Status:  <span style="color: red;">Not Paid</span></h6>
                    <h6 class="card-text text-color mt-3" v-if="Investment.isPaid===true">Status:  <span style="color: #48c074;">Paid</span></h6>
                    <h6 class="card-text text-color mt-3">Date Created:  <span style="color: #48c074;">{{Investment.date_created}}</span></h6>
                    <h6 class="card-text text-color mt-3" >Expiry Date:  <span style="color: #48c074;">{{Investment.end_date}}</span></h6>
                    <!-- <h6 class="card-text text-color mt-3">Days Left:  <span style="font-weight: bold;">{{Investment.end_date}}</span></h6> -->
                     <div class="text-center mt-4">
                      <button v-if="Investment.isPaid === false" @click="Pay()" class="btn btn-fund">Pay Now</button>
                    </div>
                    <div class="text-center mt-4">
                      <v-btn rounded dark class="text-none" text-none color="red" large @click="dialog=true">CANCEL</v-btn>

                    </div>
            </div>
            </div>
        </div>
        </div>
    </div>
        
</v-container>


  </div>
</template>

<script>
export default {
  data(){
    return{
      dialog:false,
      cancelledDialog:false,
      loader : false,
      msg:'',
      errorMessage:false
    }
  },
  methods:{
    getImageUrl(url){
      return url
    },
    Pay(){
      this.$router.push('/invest')

    },
    cancel(){
      this.loader=true
      this.$store.dispatch("CancelInvestment", this.Investment._id)
      .then(()=>{    
        this.loader = false 
        this.dialog = false
        this.cancelledDialog=true
      })
      .catch((error)=>{
        this.loader = false
        this.msg= error.response.data.message.toUpperCase()
        this.errorMessage =true
                  
      });
        
      
    },
    
  },
  computed:{
    Investment(){
       let invest= this.$store.state.farm.investmentbyid
        if (invest.units_bought===""){invest.units_bought=0}
        if (invest.amount_paid===""){invest.amount_paid='0.00'}else{
          invest.amount_paid = parseFloat(invest.amount_paid).toFixed(2)
          invest.amount_paid = invest.amount_paid.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        if (invest.estimated_return==="" || !invest.estimated_return){invest.estimated_amount='0.00'}else{
          invest.estimated_return = parseFloat(invest.estimated_return).toFixed(2)
          invest.estimated_return = invest.estimated_return.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        invest.date_created = invest.date_created.slice(0, 19).replace('T', ' ')
        invest.end_date = invest.end_date.slice(0, 19).replace('T', ' ')
        invest.cost = parseFloat(invest.cost).toFixed(2)
        invest.cost = invest.cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return invest
    }
  }

}
</script>

<style scoped>
.btn-fund{
    background: #48c074;
    border-radius: 38.5px;
    color: #fff;
    padding: 10px 20px;
    transition: all 0.5s ;
  }
  .btn-fund.active{
    background: #fff;
    box-shadow: 0px -2px 10px rgba(255, 255, 255, 0.14), 0px 4.5px 10px rgba(255, 255, 255, 0.14);
    color: #48c074;
    border: 1px solid #48c074;
    transition: all 0.5s ;
  }
  .btn-fund:hover{
    background: #fff;
    box-shadow: 0px -2px 10px rgba(255, 255, 255, 0.14), 0px 4.5px 10px rgba(255, 255, 255, 0.14);
    color: #48c074;
    border: 1px solid #48c074;
  }
  .btn-fund.active:hover{
    background: #48c074;
    box-shadow: 0px -2px 10px rgba(255, 255, 255, 0.14), 0px 4.5px 10px rgba(255, 255, 255, 0.14);
    color: #fff;
    
  }
  .text-color{
    color: #033953;
}

</style>